import React from 'react';
import * as Yup from 'yup';
import { printAction } from "../../../../actions";
import { PRINT } from "../../../../consts/methods.consts";
import { StylishCell } from '../components/cells';


const ResourcePersonEvaluationReportConfig = {
    searchApi: 'xceed.api.report.module_evaluation.get_resource_person_evaluation_report',
    alert: 'Reminder: Specify a program to receive reports.',
    excelFileName: 'module-wise-resource-persons-comments-report',
    title: 'Resource Person Evaluation Report',
    // extraActionsAsMenu: true,
    pagination: false,
    sections: [
        {
            selectionTitle: "Filters",
            grid: { base: 1, md: 2, lg: 4, xl: 4 },
            filters: [
                {
                    is_required: true,
                    label: 'Program',
                    key: 'program',
                    type: 'form-online-search',
                    methodBody: {},
                    optionMethod: 'xceed.api.report.module_evaluation.get_all_programs',
                    validationSchema: Yup.string().required('Program is required'),
                    onChange: (formik: any) => {
                        if (!formik.values.program) {
                            formik.setFieldValue('resource_person', '')
                        }
                    }
                },
                {
                    label: 'Resource Person',
                    key: 'resource_person',
                    type: 'form-online-search',
                    methodBody: { "program": "program" },
                    optionMethod: 'xceed.api.report.module_evaluation.get_resource_persons_by_program',
                    disabledBaseOn: ["program"],

                },
            ]
        }],

    tableConfig: {
        column: [
            {
                header: "Module Name",
                accessor: "program_module_title",
                width: 400
            },
            {
                header: "Session",
                accessor: "session",
                width: 400
            },
            {
                header: "Resource Person",
                accessor: "resource_person",
                width: 150
            },
            {
                header: "Overall Marks",
                accessor: "overall_rating",
                width: 50,
                headerOptions: {
                    className: " !justify-end"
                },
                customRenderer: (value: any, item: any) => React.createElement(StylishCell, { className: "flex justify-end", value })
            },
        ]
    },
    actions: [

        {
            text: "Print Report",
            onClick: async (filter: any, data: any, setLoading: any) => {
                if (filter.program && filter.resource_person) {
                    setLoading(true)
                    setLoading(true);
                    try {
                        await printAction(PRINT.PRINT_RESOURCE_PERSON_EVALUATION_REPORT, { filter }, setLoading);
                    } catch (error: any) {
                        setLoading(false);
                        const newError: any = new Error("Unable to print report");
                        newError.title = "Error";
                        newError.status = "error";
                        throw newError;
                    }
                }
                else {
                    const error: any = new Error('Please select a program and resource person');
                    error.title = 'Warning';
                    error.status = 'warning';
                    throw error
                }
            },
            buttonVariant: "solid",
            buttonColorScheme: "teal"
        }
    ]
}

export default ResourcePersonEvaluationReportConfig